"use client"

import React from "react"
import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"
import InputText from "components/Input/InputText"
import { useFormik, FieldArray, FormikProvider } from "formik"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import MyEditor from "components/MyEditor"

export const Highlight2Content = ({
    validation = { values: {} },
    pageView,
}) => {
    // let highlightCards2 = validation.values.highlightCards2 ?? [{
    //     attachmentField: "highlightCards2",
    //     attachmentName: "-",
    //     attachmentRawName: "-",
    //     attachmentType: "-",
    //     attachmentTitle: "",
    //     attachmentAlt: "",
    //     attachmentExtension: "0",
    //     attachmentSize: "0",
    //     attachmentStatus: "active",
    // }];
    // validation.values.highlightCards2 = (validation.values.highlightCards2 ?? []).length > 0 ? validation.values.highlightCards2 : highlightCards2;

    return (
        <Col className="col-12 mb-3">
            <label htmlFor="category_name" className="col-md-12 col-form-label">
                <h5 className="card-header bg-transparent border-bottom text-uppercase">
                    <i className="bx bx-cube-alt"></i> Highlight Card
                </h5>
            </label>
            <div className="col-md-12">
                <FieldArray name="highlightCards2">
                    {({ push, remove }) => (
                        <>
                            {(validation.values.highlightCards2 || []).map((row, index) => {
                                return (
                                    <div key={index}>
                                        <Row>
                                            <Col className="col-11 mb-3">
                                                <Row>
                                                    <Col className="col-12 mb-3">
                                                        <div className="col-md-12">
                                                            <PopupAttachment
                                                                typeDetail="single"
                                                                typeUpload="ImageMap"
                                                                upload="Image"
                                                                prefixName={`page-iconLinkOut${index}`}
                                                                label={`Highlight Image ${index + 1}`}
                                                                required={false}
                                                                description="description"
                                                                widthSize={1200}
                                                                heightSize={720}
                                                                value={
                                                                    validation.values.highlightImages2?.[index]
                                                                }
                                                                onChange={(value = {}, idx) => {
                                                                    console.log("🚀 onChange ~ value:", value)
                                                                    console.log("🚀 onChange ~ index:", index)
                                                                    let tmpArray = _.cloneDeep(
                                                                        validation.values.highlightImages2
                                                                    )
                                                                    tmpArray[index] = value
                                                                    validation.setFieldValue(
                                                                        "highlightImages2",
                                                                        tmpArray
                                                                    )
                                                                }}
                                                                onRemove={index => {
                                                                    console.log("🚀 onChange ~ index:", index)
                                                                    let tmpArray = _.cloneDeep(
                                                                        validation.values.highlightImages2
                                                                    )
                                                                    tmpArray.splice(index, 1)
                                                                    validation.setFieldValue(
                                                                        "highlightImages2",
                                                                        tmpArray
                                                                    )
                                                                }}
                                                            />
                                                            {/* {validation.touched[`iconLinkOut${index}`] && validation.errors[`iconLinkOut${index}`] && (
                                                                   <div type="invalid" className="invalid-feedback d-block">
                                                                     {validation.errors[`iconLinkOut${index}`]}
                                                                   </div>
                                                                 )} */}
                                                        </div>
                                                        <hr />
                                                    </Col>
                                                    <Col className="col-12 mb-3">
                                                        <label
                                                            htmlFor={`titleLink${index}`}
                                                            className="col-md-12 col-form-label"
                                                        >
                                                            Highlight Detail {index + 1}
                                                            {/* <span className="t-require">*</span> */}
                                                        </label>
                                                        <div className="col-md-12">
                                                            <MyEditor
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                name={`titleLink${index}`}
                                                                onChange={(e, editor) => {
                                                                    const newValue = editor.getData()
                                                                    let tmpArray = _.cloneDeep(
                                                                        validation.values.highlightCards2
                                                                    )
                                                                    tmpArray[index].attachmentTitle = newValue
                                                                    validation.setFieldValue(
                                                                        "highlightCards2",
                                                                        tmpArray
                                                                    )
                                                                }}
                                                                value={row?.attachmentTitle || ""}
                                                                invalid={
                                                                    validation.touched.highlightCards2?.[index]
                                                                        ?.attachmentTitle &&
                                                                        validation.errors.highlightCards2?.[index]
                                                                            ?.attachmentTitle
                                                                        ? true
                                                                        : false
                                                                }
                                                                disabled={pageView === "view"}
                                                                errorText={
                                                                    validation.errors.highlightCards2?.[index]
                                                                        ?.attachmentTitle
                                                                }
                                                            />
                                                            {validation.touched.highlightCards2?.[index]
                                                                ?.attachmentTitle &&
                                                                validation.errors.highlightCards2?.[index]
                                                                    ?.attachmentTitle && (
                                                                    <div
                                                                        type="invalid"
                                                                        className="invalid-feedback d-block"
                                                                    >
                                                                        {
                                                                            validation.errors.highlightCards2?.[index]
                                                                                ?.attachmentTitle
                                                                        }
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col className="col-12 mb-3">
                                                        <label
                                                            htmlFor={`linkOut${index}`}
                                                            className="col-md-12 col-form-label"
                                                        >
                                                            Link {index + 1}
                                                        </label>
                                                        <div className="col-md-12">
                                                            <InputText
                                                                className="form-control"
                                                                type="text"
                                                                placeholder=""
                                                                name={`linkOut${index}`}
                                                                onChange={e => {
                                                                    const newValue = e.target.value
                                                                    let tmpArray = _.cloneDeep(
                                                                        validation.values.highlightCards2
                                                                    )
                                                                    tmpArray[index].attachmentAlt = newValue
                                                                    validation.setFieldValue(
                                                                        "highlightCards2",
                                                                        tmpArray
                                                                    )
                                                                }}
                                                                maxLength={9999}
                                                                value={row?.attachmentAlt || ""}
                                                                invalid={
                                                                    validation.touched.highlightCards2?.[index]
                                                                        ?.attachmentAlt &&
                                                                        validation.errors.highlightCards2?.[index]
                                                                            ?.attachmentAlt
                                                                        ? true
                                                                        : false
                                                                }
                                                                disabled={pageView === "view"}
                                                                errorText={
                                                                    validation.errors.highlightCards2?.[index]
                                                                        ?.attachmentAlt
                                                                }
                                                            />
                                                            {validation.touched.highlightCards2?.[index]
                                                                ?.attachmentAlt &&
                                                                validation.errors.highlightCards2?.[index]
                                                                    ?.attachmentAlt && (
                                                                    <div
                                                                        type="invalid"
                                                                        className="invalid-feedback d-block"
                                                                    >
                                                                        {
                                                                            validation.errors.highlightCards2?.[index]
                                                                                ?.attachmentAlt
                                                                        }
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            {index > 0 && (
                                                <Col
                                                    className="col-1 pl-0 pt-3"
                                                    style={{ paddingLeft: 0 }}
                                                >
                                                    <label
                                                        htmlFor="category_name"
                                                        className="col-md-12 col-form-label"
                                                    >
                                                        {/* <span className="t-require">*</span> */}
                                                    </label>
                                                    <div className="">
                                                        <Button
                                                            type="button"
                                                            onClick={() => {
                                                                remove(index)
                                                            }}
                                                        >
                                                            DELETE
                                                        </Button>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                )
                            })}
                            <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                    const tmp = {
                                        attachmentField: "highlightCards2",
                                        attachmentName: "-",
                                        attachmentRawName: "-",
                                        attachmentType: "-",
                                        attachmentTitle: " ",
                                        attachmentAlt: " ",
                                        attachmentExtension: "0",
                                        attachmentSize: "0",
                                        attachmentStatus: "active",
                                    }
                                    if (validation.values.highlightCards2.length < 10) {
                                        push(tmp)
                                    }

                                    console.log(validation.values.highlightCards2)
                                }}
                            >
                                <i className="mdi mdi-plus"></i> ADD Highlight
                            </Button>
                        </>
                    )}
                </FieldArray>
            </div>
        </Col>
    )
}
